import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyEivPayerDxcIcon = lazy(() => import('./svg-components/eiv-payer-dxc-icon'));

const EivPayerDxcIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyEivPayerDxcIcon {...rest} />
  </Suspense>
);

export default EivPayerDxcIcon;
